import * as React from "react";

import { resolveAnalyticsElement } from "@/lib/analytics/analyticsElement";
import type { AnalyticsElementId } from "@/lib/analytics/analyticsElementId";
import { cn } from "@/lib/utils";

type ExternalLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  /**
   * Structured element id wiring click analytics: stamps the `data-analytics-*` marker
   * attributes, queues `fe_element_clicked`, and starts a best-effort keepalive
   * outbox drain (the navigation may unload the document before the poller runs).
   */
  analyticsElementId?: AnalyticsElementId;
};

/**
 * Plain anchor for navigation that leaves the SPA — external URLs, mailto, and
 * downloads. Use `InternalLink` for in-app routes.
 */
export const ExternalLink = ({ analyticsElementId, className, onClick, children, ...props }: ExternalLinkProps) => {
  const analyticsElement = resolveAnalyticsElement(analyticsElementId, { flushOutboxOnClick: true });

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    analyticsElement?.emitClick();
    onClick?.(event);
  };

  return (
    <a
      className={cn(className)}
      {...analyticsElement?.attributes}
      onClick={analyticsElement ? handleClick : onClick}
      {...props}
    >
      {children}
    </a>
  );
};
